module.exports = __webpack_public_path__ + "img/_options_menu.278a32bc.svg";